module.exports = __webpack_public_path__ + "mainassets/img/tile-2-4h.a7ae60d3.jpg";